// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__356xI","controls":"styles_controls__3Ytxj","charLimit":"styles_charLimit__8VkBJ","input":"styles_input__sTcCo","send":"styles_send__3qtsR"};